import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { LoadingSmrComponent } from './loading-smr.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule
  ],
  declarations: [LoadingSmrComponent],
  exports: [LoadingSmrComponent]
})
export class LoadingSmrModule { }
